import React from 'react'
import { Check } from 'lucide-react'

const MultiLocationSection = () => {
  const benefits = [
    "Compare performance across locations in real time.",
    "Spot which store is thriving — and which needs attention.",
    "Save trips between shops with a quick online snapshot."
  ]

  const locations = [
    {
      name: "Downtown",
      visitors: 320,
      change: "+15%",
      status: "positive"
    },
    {
      name: "Northside", 
      visitors: 145,
      change: "+2%",
      status: "neutral"
    },
    {
      name: "Mall Location",
      visitors: 89,
      change: "-12%",
      status: "negative"
    }
  ]

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'positive':
        return 'bg-green-50 text-green-600'
      case 'negative':
        return 'bg-red-50 text-red-600'
      default:
        return 'bg-gray-50 text-gray-600'
    }
  }

  return (
    <section className="section-padding">
      <div className="container-padding">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              See all your stores at a glance — from anywhere.
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Whether you manage two shops or ten, FlowBeatIQ gives you instant 
              visibility into each location's traffic without leaving your home or office.
            </p>
            
            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0" />
                  <span className="text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="card-shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-6">All Locations Overview</h3>
            <div className="space-y-4">
              {locations.map((location, index) => (
                <div key={index} className={`flex justify-between items-center p-4 rounded-lg transition-all duration-200 hover:scale-105 ${getStatusColor(location.status)}`}>
                  <div>
                    <div className="font-semibold text-gray-900">{location.name}</div>
                    <div className="text-sm text-gray-600">{location.visitors} visitors today</div>
                  </div>
                  <div className={`font-semibold ${
                    location.status === 'positive' ? 'text-green-600' : 
                    location.status === 'negative' ? 'text-red-600' : 
                    'text-gray-600'
                  }`}>
                    {location.change}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MultiLocationSection